import { variablesDomApplier } from './variablesDomApplier'
import { variables } from './variablesCompNode'
import { variablesVariants } from './variablesVariantsCompNode'
import type { VariablesCssFeature } from './variables.types'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const variablesCssFeature: VariablesCssFeature = {
	featureName: 'variables',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { variables, variablesVariants },
	intermediateNodes: {
		compData: compInfoNodes.compData,
	},
	dataMaps: ['variables'],
	domApplier: variablesDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(variablesCssFeature)
}
export const editor: BindFeature = page
